import { TrimixTemplate, MainLayout } from "@/design-system/Templates";
import Header from "@/design-system/Organisms/Header";
import { headerConfig } from "@/design-system/Organisms/Header/Header.config";
import { Footer } from "@/design-system/Organisms";
import { useScrollToTopOnMount } from "@/hooks/useScrollToTopOnMount";

const TrimixPage = () => {
  useScrollToTopOnMount();
  return (
    <MainLayout
      header={<Header {...headerConfig} />}
      sidebar={null}
      className=""
      footer={<Footer />}
    >
      <TrimixTemplate />
    </MainLayout>
  );
};

export default TrimixPage;
